export default __webpack_public_path__ + "0904e95a2e6911e843a05d5214196010.png";